class ApiResponse {
  constructor({ status, statusCode, message, errorMessage, response }) {
    this.status = status;
    this.statusCode = statusCode;
    this.message = message;
    this.errorMessage = errorMessage;
    this.response = response; // ANY object
  }

  static fromJson(json) {
    return new ApiResponse({
      status: json.status,
      statusCode: json.statusCode,
      message: json.message,
      errorMessage: json.errorMessage,
      response: json.response   // dynamic (no fixed model)
    });
  }
}
export default ApiResponse;
